import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fto-logo',
  template: '<img class="logo-image" alt="PowerReady Logo" src="assets/img/PowerReady-logo-white.png" />',
  styleUrls: ['./logo.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LogoComponent {}
